import * as React from 'react';

import classNames from 'classnames';

import { EMainMenuBadge } from '@enums';

import { IMainMenuBadgeProps } from './types';

import * as s from './MainMenuBadge.scss';

export const MainMenuBadge = (props: IMainMenuBadgeProps ) => {
	const {
		className,
		type,
		text,
	} = props;
	const badgeClassname = classNames(
		s.block,
		className,
		{ [s.counter]: type === EMainMenuBadge.COUNTER || type === EMainMenuBadge.APP_NOTIFY },
		{ [s.appNew]: type === EMainMenuBadge.APP_NEW },
		{ [s.appHit]: type === EMainMenuBadge.APP_HIT },
		{ [s.fix]: type === EMainMenuBadge.APP_HIT || type === EMainMenuBadge.APP_NEW },
	);
	let badgeText = null;

	switch (type) {
		case EMainMenuBadge.APP_HIT:
			badgeText = 'HIT';
			break;
		case EMainMenuBadge.APP_NEW:
			badgeText = 'NEW';
			break;
		case EMainMenuBadge.APP_NOTIFY:
			badgeText = '!';
			break;
		default:
			badgeText = text || '';
	}

	return <div className={badgeClassname}>
		{badgeText?.length && badgeText}
	</div>;
};
